import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireRole } from "@/utils/route-guards";
import { AREA_ROLES } from "@/utils/errandPath";
import { AdminLayout } from "@/components/layout/admin/AdminLayout";

export const Route = createFileRoute("/group-legal")({
  beforeLoad: ({ context, location }) => {
    requireRole(context, location, AREA_ROLES["/group-legal"]);
  },
  component: GroupLegalAreaLayout,
});

function GroupLegalAreaLayout() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
